<template>
  <div :class="$b()">
    <div :class="$b('column', { 'icon-wrapper': true })">
      <VisionIcon
        icon="certified-b-corp"
        size="stretch"
        colour="black"
        :class="$b('icon')"
      />
    </div>

    <div :class="$b('column')">
      <BaseHeading
        tag="h2"
        size="h1"
        :class="$b('title')"
      >
        We are a
        <br />
        <span :class="$b('gradient')">Certified B Corp™</span>
      </BaseHeading>

      <SecondaryLineLink
        is-button
        :class="$b('button')"
        @click="() => openModal('b-corp-certified')"
      >
        {{ $tr('Learn More') }}
      </SecondaryLineLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BCorpBanner',
  setup () {
    const modalStore = useModalStore()

    return {
      openModal (slug) {
        modalStore.OPEN_MODAL_PAGE({ slug })
      }
    }
  }
}
</script>

<style lang="postcss">
.BCorpBanner {
  &__column--icon-wrapper {
    @apply mdMax:mb-md;
  }

  @screen md {
    @apply flex flex-wrap flex-row-reverse items-center -mx-4 overflow-hidden;

    &__column {
      @apply px-4 overflow-hidden w-1/2;

      &--icon-wrapper {
        @apply flex justify-center;
      }
    }
  }

  &__title {
    @apply t-align-fix text-2xl
      md:-mr-md
      relative;

    z-index: 1;

    @screen xxs {
      font-size: 40px;
    }

    @screen lg {
      font-size: 48px;
    }
  }

  &__gradient {
    @apply t-gradient;
  }

  &__button {
    @apply block mt-[60px] mb-xxxs;

    @screen md {
      @apply mt-20;
    }
  }

  &__icon {
    width: 84px;
    height: 84px;

    @screen sm {
      width: 225px;
      height: 225px;
    }

    @screen md {
      width: 322px;
      height: 322px;
    }

    .VisionIcon__svg {
      height: 100%;
    }
  }
}
</style>
